import { Map } from 'immutable';
import { isEmpty } from 'lodash';

import { convertActionToPreviousStructure } from 'app/api';
import { NAMESPACE_INTERESTING_MATCHES } from 'app/constants/Context';
import {
  SET_INTERESTING_MATCHES_GRID_STAKE_TYPES,
  SET_INTERESTING_MATCHES_ORDER_KEY,
} from 'app/redux/betting-presentation/grid/actions';
import {
  buildMainLineStakesGrid,
  transformMainLineStakesGrid,
  transformStakeTypeGroupBySportId,
  updateStakeTypeGroupBySportId,
} from 'app/redux/betting-presentation/grid/reducers';
import { TRANSFORM_SSR_STATE } from 'app/redux/ssrState';

import {
  APPLY_INTERESTING_MATCHES_STATE,
  fetchInterestingMatches,
} from '../actions';

const initialState = Map({
  stakeTypeGroupBySportId: Map(),
  mainLineStakesGrid: Map(),
  orderKey: null,
});

/**
 * @private
 * @param {Immutable.Map<string, Immutable.Map<number, *>>} state
 * @param {Immutable.Map<string, Immutable.Map<string, *>>} entities – entities state
 * @return {Immutable.Map<string, Immutable.Map<number, *>>} new state
 */
function handleSportEntitiesDiff(state, entities) {
  return state.update('stakeTypeGroupBySportId', (state) => {
    return updateStakeTypeGroupBySportId(state, entities, NAMESPACE_INTERESTING_MATCHES);
  });
}

/**
 * @private
 * @param {Immutable.Map<string, Immutable.Map<number, *>>} state
 * @param {Immutable.Map<string, *>} entities
 * @return {Immutable.Map<string, Immutable.Map<number, *>>} new state
 */
function handleMainLineStakesGridChange(state, entities) {
  return state.set('mainLineStakesGrid', buildMainLineStakesGrid(entities));
}

export default function (state = initialState, namespace, action, entities) {
  switch (action.type) {
    case fetchInterestingMatches.fulfilled.toString():
    case APPLY_INTERESTING_MATCHES_STATE: {
      const convertedAction = convertActionToPreviousStructure(action);

      if (!convertedAction.payload?.diff) {
        return state;
      }

      if (!isEmpty(convertedAction.payload.diff.sports)) {
        state = handleSportEntitiesDiff(state, entities);
      }

      if (!isEmpty(convertedAction.payload.diff.matches)) {
        state = handleMainLineStakesGridChange(state, entities);
      }

      return state;
    }

    case SET_INTERESTING_MATCHES_GRID_STAKE_TYPES:
      return state.update('stakeTypeGroupBySportId', (state) => {
        const { sportId, stakeGroupTypeIds } = action.payload;
        return state.set(sportId, stakeGroupTypeIds);
      });

    case SET_INTERESTING_MATCHES_ORDER_KEY:
      return state.set('orderKey', action.payload.key);

    case TRANSFORM_SSR_STATE:
      if (Map.isMap(state)) {
        return state; // already transformed (initial state case)
      }

      return Map({
        mainLineStakesGrid: transformMainLineStakesGrid(state.mainLineStakesGrid),
        stakeTypeGroupBySportId: transformStakeTypeGroupBySportId(
          state.stakeTypeGroupBySportId,
          namespace,
          entities,
        ),
        filterKey: state.filterKey,
        orderKey: state.orderKey,
      });

    default:
      return state;
  }
}
